var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-main-index"},[_c('div',{staticClass:"bx"},[_c('keep-alive',[_c(_vm.navData[_vm.navActiveIndex].com,{tag:"components"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }